import { render, staticRenderFns } from "./BCXRadio.vue?vue&type=template&id=419fc494"
import script from "./BCXRadio.vue?vue&type=script&lang=ts"
export * from "./BCXRadio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports